/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Jr_2_DInputs */

const en_cp_jr_2_d = /** @type {(inputs: Cp_Jr_2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams of 3–5 run the full loop with a lecturer or problem owner as the client who approves phases.`)
};

const id_cp_jr_2_d = /** @type {(inputs: Cp_Jr_2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim 3–5 orang menjalankan loop penuh dengan dosen atau pemilik masalah sebagai klien yang menyetujui fase.`)
};

/**
* | output |
* | --- |
* | "Teams of 3–5 run the full loop with a lecturer or problem owner as the client who approves phases." |
*
* @param {Cp_Jr_2_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_jr_2_d = /** @type {((inputs?: Cp_Jr_2_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Jr_2_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_jr_2_d(inputs)
	return en_cp_jr_2_d(inputs)
});